// extracted by mini-css-extract-plugin
export var hasEyebrow = "job-search-module--hasEyebrow--4a868";
export var headlineWrapper = "job-search-module--headlineWrapper--a9300";
export var jobSearchBody = "job-search-module--jobSearchBody--d4770";
export var jobSearchField = "job-search-module--jobSearchField--6f979";
export var jobSearchForm = "job-search-module--jobSearchForm--3695c";
export var jobSearchGrid = "job-search-module--jobSearchGrid--b77fb";
export var jobSearchHeadline = "job-search-module--jobSearchHeadline--09733";
export var jobSearchIcon = "job-search-module--jobSearchIcon--b4240";
export var jobSearchInput = "job-search-module--jobSearchInput--de5a3";
export var showBorder = "job-search-module--showBorder--0979a";
export var styledButtons = "job-search-module--styledButtons--a0987";
export var styledImage = "job-search-module--styledImage--e7398";
export var styledWrapper = "job-search-module--styledWrapper--8f4a1";